import React from 'react';
import { Layout } from '../components/sections/Layout';
import { FeatureAgenda } from '../components/sections/FeatureAgenda';
import { FeatureExhibitor } from '../components/sections/FeatureExhibitor';
import { PWASection } from '../components/sections/PWASection';
import { FinalCTA } from '../components/sections/FinalCTA';
export function PendantPage() {
  return <Layout data-id="element-813">
      <FeatureAgenda data-id="element-814" />
      <FeatureExhibitor data-id="element-815" />
      <PWASection data-id="element-816" />
      <FinalCTA data-id="element-817" />
    </Layout>;
}